<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <v-card class="mb-0" style="height: calc(100% - 30px)">
          <v-card-title>
            <div class="report-title">
              Hoa Hồng/Thưởng
            </div>
          </v-card-title>
          <validation-observer v-slot="{ handleSubmit }">
            <v-card-text class="policy-content-wrapper">

            <v-card-text>
              <v-radio-group v-model="defaultRadio">
                <v-row align="center">
                  <v-radio
                      label="Hoa hồng :"
                      class="item-radio-title"
                      value="rose"
                  ></v-radio>
                  <v-col cols="8" class="py-0">
                    <validation-provider
                        v-slot="{ errors }"
                        name="Nhập số tiền "
                        :rules="{numeric: true}"
                    >
                      <v-text-field
                          label="Nhập số tiền ..."
                          v-model="dataForm.rose"
                          :readonly="defaultRadio == 'bonus' || !checkAuthorization('partner-policy_update')"
                          :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <span>Vnđ/Contact thành công</span>
                </v-row>

                <v-row align="center">
                  <v-radio
                      class="item-radio-title"
                      label="Thưởng theo % :"
                      value="bonus"
                  ></v-radio>
                  <v-col cols="8" class="py-0">
                    <validation-provider
                        v-slot="{ errors }"
                        name="Nhập số % "
                        :rules="{regex: /^(?!0*[.,]0*$|[.,]0*$|0*$)/, min_value: 0, max_value: 100}"
                    >
                      <v-text-field
                          v-model="dataForm.bonus"
                          label="Nhập số % ..."
                          :readonly="defaultRadio == 'rose' || !checkAuthorization('partner-policy_update')"
                          :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <span>Doanh thu</span>
                </v-row>
              </v-radio-group>
            </v-card-text>

            <div class="text-center mb-4">
              <v-btn
                  v-if="checkAuthorization('partner-policy_update')"
                  class="primary mx-0 btn-apply-policy"
                  @click.prevent="handleSubmit(applyPolicy)"
              >Áp dụng
              </v-btn>
            </div>
          </v-card-text>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'
const DashboardPartnerRepository = RepositoryFactory.get('dashboard_partner')

export default {
  components: {},
  data () {
    return {
      dataForm: {
        rose: '',
        bonus: ''
      },
      defaultRadio: 'rose'
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData () {
      this.loading = this.$loading.show()
      const response = await DashboardPartnerRepository.policyCTV({})
      if (response.success) {
        this.dataForm = _.get(response, 'data');
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        })
      }
      this.loading.hide();
    },
    async applyPolicy() {
      this.loading = this.$loading.show();
      const params = {
        type: this.defaultRadio,
        number: this.defaultRadio == 'rose' ? +this.dataForm.rose : +this.dataForm.bonus
      }
      const response = await DashboardPartnerRepository.applyPolicy(params)
      this.loading.hide();
      if (response.success) {
        this.$swal({
          title: _.get(response, 'message', 'Áp dụng chính sách cho CTV thành công!'),
          timer: 3000
        });
        this.fetchData();
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        })
      }
    },
  },
}
</script>

<style scoped>
.v-card {
  overflow: visible !important;
  overflow-x: hidden;
}
.report-title {
  position: absolute;
  top: -30px;
  background-color: #e91e63;
  padding: 5px 20px;
  color: white;
  border-radius: 5px;
}
.table-layout th {
  min-width: unset !important;
  width: unset !important;
}
.policy-content-wrapper {
  padding: 16px 100px !important;
}
.item-radio-title {
  width: 15%;
}
.v-text-field > .v-input__control > .v-input__slot {
  width: 60%;
}
.btn-apply-policy {
  border-radius: 25px;
}
</style>
